import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';

import { Tabs } from '@mantine/core';

import { Library, Sparkles } from 'lucide-react';
import Header from '@/components/Layout/components/Header';
import Agents from '@/pages/Agents';
import Libraries from '@/pages/Libraries';
import ProjectBreadcrumb from '@/modules/Projects/components/ProjectBreadcrumb/ProjectBreadcrumb';
import PublishProjectButton from '@/modules/Projects/components/PublishProjectButton';

import { PATHS } from '@/const';
import { useProjectQuery } from '@/services/designer/projects/projects.queries';
import { getProjectName } from '@/modules/Projects/Project.utils';
import { PageContainer } from '@/components/PageContainer/PageContainer';

const ProjectLegacy: FC = () => {
    const navigate = useNavigate();
    const { projectId, tab } = useParams();
    const { data: project } = useProjectQuery(false, projectId);
    const handleTabChange = (value: string | null) => {
        if (value) {
            navigate(`${PATHS.projects}/${projectId}/${value}`);
        }
    };

    return (
        <>
            <Helmet>
                <title>NEWO - Project</title>
            </Helmet>

            <PageContainer className="px-0" h="100%" w="100%">
                <Header
                    isSearchVisible
                    breadcrumbs={[
                        {
                            label: <ProjectBreadcrumb projectId={projectId} />
                        }
                    ]}
                />
                <div className="px-4 pt-4">
                    <div className="flex gap-4 justify-end py-2">
                        <PublishProjectButton project={project}>
                            Publish &quot;{getProjectName(project)}&quot;
                            project
                        </PublishProjectButton>
                    </div>
                    <Tabs
                        defaultValue={tab ?? 'agents'}
                        keepMounted={false}
                        onChange={handleTabChange}
                    >
                        <Tabs.List>
                            <Tabs.Tab leftSection={<Sparkles />} value="agents">
                                Agents
                            </Tabs.Tab>
                            <Tabs.Tab
                                leftSection={<Library />}
                                value="libraries"
                            >
                                Libraries
                            </Tabs.Tab>
                        </Tabs.List>
                        <Tabs.Panel value="agents">
                            <Agents projectId={projectId} />
                        </Tabs.Panel>
                        <Tabs.Panel value="libraries">
                            <Libraries projectId={projectId} />
                        </Tabs.Panel>
                    </Tabs>
                </div>
            </PageContainer>
        </>
    );
};

export default ProjectLegacy;
